import { getInverseTransformMatrix, getTransformMatrix } from '../core/transform2';
import { type ITransformRT2, type IVector2, Matrix23, Vector2 } from '@seddi/math-v2';

/**
 * Returns true if logo (with corners) is fully inside the region bounds.
 */
export const isInside = (() => {
  const EPSILON = 1e-5;
  const logoCorners = [new Vector2(), new Vector2(), new Vector2(), new Vector2()];
  const transformedCorners = [new Vector2(), new Vector2(), new Vector2(), new Vector2()];
  const bMin = new Vector2();
  const bMax = new Vector2();
  const lc = new Vector2();
  const lm = new Matrix23();
  const logoMatrix = new Matrix23();

  return (
    logoSize: IVector2,
    logoTransform: ITransformRT2,
    regionSize: IVector2,
    regionTransform: ITransformRT2,
  ): boolean => {
    const halfWidth = logoSize.x * 0.5;
    const halfHeight = logoSize.y * 0.5;

    logoCorners[0].set(-halfWidth, -halfHeight);
    logoCorners[1].set(halfWidth, -halfHeight);
    logoCorners[2].set(halfWidth, halfHeight);
    logoCorners[3].set(-halfWidth, halfHeight);

    getTransformMatrix(logoTransform, logoMatrix);
    for (let i = 0; i < 4; i++) {
      transformedCorners[i].copyFrom(logoCorners[i]);
      logoMatrix.transformRef(transformedCorners[i]);
    }

    getInverseTransformMatrix(regionTransform, lm);
    for (let i = 0; i < 4; i++) {
      lc.copyFrom(transformedCorners[i]);
      lm.transformRef(lc);
      transformedCorners[i].copyFrom(lc);
    }

    bMin.x = regionSize.x * -0.5 - EPSILON;
    bMin.y = regionSize.y * -0.5 - EPSILON;
    bMax.x = regionSize.x * 0.5 + EPSILON;
    bMax.y = regionSize.y * 0.5 + EPSILON;

    for (let i = 0; i < 4; i++) {
      const corner = transformedCorners[i];
      if (corner.x < bMin.x || corner.x > bMax.x || corner.y < bMin.y || corner.y > bMax.y) {
        return false;
      }
    }

    return true;
  };
})();
